// extracted by mini-css-extract-plugin
export default {"students":"Students_students__nz1fS","item":"Students_item__cjQDV"};